/* oxlint-disable typescript/no-explicit-any */

type MemoizedFunction<T extends (...args: any[]) => any> = (
  ...args: Parameters<T>
) => Promise<ReturnType<T>>;

const cacheMap = new Map<string, { value: any; expiresAt: number }>();

function memoize<T extends (...args: any[]) => any>(
  key: string,
  fn: T,
  duration = 1000 * 60 * 5,
): MemoizedFunction<T> {
  return async (...args: Parameters<T>): Promise<ReturnType<T>> => {
    const now = Date.now();
    const cachedValue = cacheMap.get(key);
    if (cachedValue != null) {
      const { value, expiresAt } = cachedValue;
      if (now < expiresAt) {
        return value;
      }
    }

    try {
      const value = await fn(...args);
      cacheMap.set(key, { value, expiresAt: now + duration });
      return value;
    } catch {
      console.warn(`key: ${key} failed to update in cache. Using stale value.`);
      const value = cacheMap.get(key)?.value;
      cacheMap.set(key, { value, expiresAt: now + duration });
      return value;
    }
  };
}

export const cache = {
  memoize,
};
